import moment from "moment"
import { DEFAULT_DATE_FORMAT, REGEX_REPLACE_POINT } from "../Constants/ProjectReportConstants";


export const formatDate = (date) => {
  if (!date) return '-';

  return moment(date).format(DEFAULT_DATE_FORMAT).toUpperCase().replace(REGEX_REPLACE_POINT, '')
}